import { useGetListLocalizationWithPaginationLazyQuery } from "@stepapp/core";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../hooks/redux";

export const useLocalizationCheck = () => {
  const { localizationId } = useAppSelector(({ appConfig }) => appConfig);
  const [modalVisible, setModalVisible] = useState(false);

  const [listLocalizations] = useGetListLocalizationWithPaginationLazyQuery({
    variables: { limit: 20, page: 1 },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await listLocalizations();
        const supportedCities = data?.listLocalizationWithPagination?.items;
        const hasLocalization = supportedCities?.some(
          (localization) => localization.id === localizationId,
        );
        if (!(localizationId && hasLocalization)) {
          setModalVisible(true);
        }
      } catch (_error) {}
    };

    fetchData();
  }, [listLocalizations, localizationId]);

  return { modalVisible, setModalVisible };
};
